export default {
  props: {
    placeholder: {
      type: String,
      default: 'Pick date'
    },
    inputClass: {
      type: [Object, Array],
      default() {
        return {}
      }
    },
    value: String
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-datepicker/src/BasicInput.js
// module id = 33
// module chunks = 0